import axios from 'axios'

export const HTTP = axios.create({
  baseURL: process.env.URL_SSO_API
})

export function setAuthorizationHeader (token) {
  if (token) {
    HTTP.defaults.headers.common['Authorization'] = `Bearer ${token}`
  }
}

export function getAsync (url, head = {}) {
  return new Promise(async resolve => {
    const response = {
      data: null,
      status: 0
    }
    try {
      const res = await HTTP.get(url, {
        headers: head
      })
      response.status = res.status
      if (!res.data) {
        response.message = `No data received from "${url}"`
      }
      response.data = res.data
    } catch (err) {
      if (err.response) {
        response.status = err.status
      }
      response.error = err
    }

    resolve(response)
  })
}

export function postAsync (url, data, head = {}) {
  return new Promise(async resolve => {
    const response = {
      data: null,
      status: 0
    }
    try {
      const res = await HTTP.post(url, data, {
        headers: head
      })
      response.status = res.status
      if (!res.data) {
        response.message = `No data received from "${url}"`
      }
      response.data = res.data
    } catch (err) {
      if (err.response) {
        response.status = err.response.status
      }
      response.error = err
    }

    resolve(response)
  })
}

export function putAsync (url, data, head = {}) {
  return new Promise(async resolve => {
    const response = {
      data: null,
      status: 0
    }
    try {
      const res = await HTTP.put(url, data, {
        headers: head
      })
      response.status = res.status
      if (!res.data) {
        response.message = `No data received from "${url}"`
      }
      response.data = res.data
    } catch (err) {
      if (err.response) {
        response.status = err.response.status
      }
      response.error = err
    }

    resolve(response)
  })
}

export function deleteAsync (url, head = {}) {
  return new Promise(async resolve => {
    const response = {
      data: null,
      status: 0
    }
    try {
      const res = await HTTP.delete(url, {
        headers: head
      })
      response.status = res.status
      if (!res.data) {
        response.message = `No data received from "${url}"`
      }
      response.data = res.data
    } catch (err) {
      if (err.response) {
        response.status = err.status
      }
      response.error = err
    }

    resolve(response)
  })
}



// WEBPACK FOOTER //
// ./src/http-common.js